import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import router from '@/router';
import statuses from '@/store/statuses';

axios.defaults.baseURL = location.protocol.includes('https') ? ENV.VUE_APP_API_HTTPS : ENV.VUE_APP_API_HTTP;
const Backend = axios.create();

Backend.interceptors.response.use((response) => {
  const serverResponse = response.data;

  if (response.headers['content-type'] !== 'application/json') {
    return Promise.resolve({
      data: serverResponse,
      headers: response.headers,
    });
  }

  switch (response.status) {
    case 200:
      return Promise.resolve({
        data: serverResponse,
        headers: response.headers,
        status: statuses.LOADED
      });

    case 201:
      return Promise.resolve({
        data: serverResponse,
        headers: response.headers,
        status: statuses.LOADED
      });

    default:
      return Promise.reject({
        data: serverResponse,
        headers: response.headers,
        status: statuses.ERROR
      });
  }
}, (error) => {
  let isGetRequest = error.response.config.method === 'get';

  switch (error.response.status) {
    case 401:
      console.log('Unathorized');
      router.replace({ name: 'Login' });
      break;
    case 403:
      console.log('Forbidden error');
      // TODO
      break;
    case 422:
      console.log('Validation error');
      // TODO
      break;

    default:
      console.log('Error');
      // TODO
  }

  return Promise.reject({
    data: error.response,
    headers: error.response.headers,
    status: statuses.ERROR
  });
});

Vue.use(VueAxios, Backend);
export { axios, Backend };
